import { render, staticRenderFns } from "./SideMenuContent.vue?vue&type=template&id=47801e9e&"
import script from "./SideMenuContent.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SideMenuContent.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47801e9e')) {
      api.createRecord('47801e9e', component.options)
    } else {
      api.reload('47801e9e', component.options)
    }
    module.hot.accept("./SideMenuContent.vue?vue&type=template&id=47801e9e&", function () {
      api.rerender('47801e9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/core-layout/components/CoreHeader/components/mobile/SideMenu/SideMenuContent.vue"
export default component.exports